import React, { KeyboardEvent } from "react";

interface ChatbotSearchInputProps {
  inputValue: string;
  onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSearch: () => void;
  inputRef: React.RefObject<HTMLTextAreaElement>;
  chatInputIcon: string;
  chatInputBlackIcon: string;
  placeholder: string;
  chatbotAccess: boolean;
  onNavigateToPaywall: () => void;
}

const ChatbotSearchInput: React.FC<ChatbotSearchInputProps> = ({
  inputValue,
  onInputChange,
  onSearch,
  inputRef,
  chatInputIcon,
  chatInputBlackIcon,
  placeholder,
  chatbotAccess,
  onNavigateToPaywall,
}) => {
  // Handle focus events - check subscription before allowing focus
  const handleFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    if (!chatbotAccess) {
      e.target.blur(); // Remove focus immediately
      onNavigateToPaywall(); // Navigate to paywall
    }
  };

  // Handle key press events
  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    // Check if Enter key is pressed and not with Shift key (to allow line breaks with Shift+Enter)
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevent the default action (new line)
      if (inputValue.trim()) {
        onSearch(); // Call the search function
      }
    }
  };

  return (
    <div className="relative w-full pt-4">
      <textarea
        ref={inputRef}
        rows={1}
        value={inputValue}
        onChange={onInputChange}
        onKeyDown={handleKeyPress}
        onFocus={handleFocus}
        className="text-white bg-white/10 px-4 text-[14px] pr-12 py-3 min-h-[48px] w-full rounded-[20px] outline-none focus:outline-none resize-none overflow-y-auto"
        placeholder={placeholder}
        style={{ height: "48px" }}
      />
      <div
        className={`absolute right-4 bottom-[19px] cursor-pointer w-[24px] h-[24px] flex items-center justify-center rounded-full ${
          inputValue.trim() ? "bg-white" : "bg-white/10"
        }`}
        onClick={inputValue.trim() ? onSearch : undefined}
      >
        <img
          src={inputValue.trim() ? chatInputBlackIcon : chatInputIcon}
          alt="search"
        />
      </div>
    </div>
  );
};

export default ChatbotSearchInput;
